import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApkLoanKKBFinancial2Service from "services/Setup/LoanOrigination/Financial/ApkLoanKKBFinancial2Service";
import { notification } from "antd";

// 🔹 Initial State
const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  token: localStorage.getItem(AUTH_TOKEN) || null,
  financial2Item: [],
  fromInstallment: null,
  nettinterestItem: [],
  result: {},
};

// 🔹 Thunks
export const getAddSlice = createAsyncThunk(
  "apkLoanKKBFinancial2/getAddSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKKBFinancial2Service.getAddService(userInput);
      if (response.status === 200) return response.data;
      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      // notification.error({
      //   message: error.response?.status || "Error",
      //   description: error.response?.statusText || "Unexpected error occurred",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!",
      );
    }
  },
);

// 🔹 Thunks
export const nettinterestSlice = createAsyncThunk(
  "apkLoanKKBFinancial2/nettinterestSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKKBFinancial2Service.nettInterestService(userInput);
      if (response.status === 200) return response.data;
      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      notification.error({
        message: error.response?.status || "Error",
        description: error.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!",
      );
    }
  },
);

export const postAddSlice = createAsyncThunk(
  "apkLoanKKBFinancial2/postAddSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKKBFinancial2Service.postAddService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      }
      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      notification.error({
        message: error.response?.status || "Error",
        description: error.response?.statusText || "Unexpected error occurred",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!",
      );
    }
  },
);

// 🔹 Slice
export const ApkLoanKKBFinancial2Slice = createSlice({
  name: "apkLoanKKBFinancial2",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    resetConversion: (state) => {
      state.financial2Item = [];
      state.fromInstallment = null;
      state.result = {};
    },
  },
  extraReducers: (builder) => {
    // Pastikan convertFlatToEffectiveSlice sudah di-import dari slice lain
    builder
      .addCase(getAddSlice.pending, (state) => {
        state.loading = true;
        state.financial2Item = [];
      })
      .addCase(getAddSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.financial2Item = action.payload;
        state.fromInstallment = null;
      })
      .addCase(getAddSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.financial2Item = [];
        state.showMessage = true;
      })

      .addCase(nettinterestSlice.pending, (state) => {
        state.loading = true;
        state.nettinterestItem = [];
      })
      .addCase(nettinterestSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.nettinterestItem = action.payload;
        state.fromInstallment = null;
      })
      .addCase(nettinterestSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.nettinterestItem = [];
        state.showMessage = true;
      })

      .addCase(postAddSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(postAddSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.fromInstallment = null;
        state.nettinterestItem = action.payload;
      })
      .addCase(postAddSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

// 🔹 Export actions & reducer
export const { showNotification, hideNotification, resetConversion } =
  ApkLoanKKBFinancial2Slice.actions;
export default ApkLoanKKBFinancial2Slice.reducer;
